<!-- <div class="modal-content">
    <form [formGroup]="uploadform" (ngSubmit)="onSubmit()" role="form" class="needs-validation" novalidate>
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="activeModal.close('Close click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="modal-title" id="exampleModalLabel">Upload File(s)</h5>
        </div>

        <div class="modal-body">

            <div *ngIf="success">
                <div class="alert alert-success text-white" role="alert">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    File(s) has(ve) been uploaded successfully!
                </div>
            </div>

            <div *ngIf="!success" class="form-group mb-3">

                <div class="row">
                    <div class="col-md-8">
                        <label class="col-form-label">
                            Upload File(s)
                        </label> <br>
                        <div class="fileinput fileinput-new text-center" data-provides="fileinput"> -->
                            <!-- <div class="fileinput-new thumbnail">
                          <img src="./assets/img/image_placeholder.jpg" alt="...">
                        </div>-->
                            <!-- <div class="fileinput-preview fileinput-exists thumbnail"></div> -->
                            <!-- <div *ngFor="let item of fileToUpload, let i = index">
                                <div class="d-flex justify-content-between">
                                    {{item.name}}
                                    <button type="button" class="btn btn-danger btn-sm" (click)="removeItem(i)">
                                        <i class="fas fa-trash"></i> &nbsp; remove
                                    </button>
                                </div>
                                <div class="dropdown-divider"></div>
                            </div>

                            <div *ngIf="error || errorSize || errorQuantity" class="alert text-white alert-danger"
                                role="alert">
                                <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                {{ error }} {{ errorSize }} {{ errorQuantity }}
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">
                                    Maximum upload file size: 500 MB.
                                </label> <br>
                                <span class="btn btn-rose btn-round btn-file">
                                    <span class="fileinput-new">Select file(s)</span>
                                    <span class="fileinput-exists">Upload more files</span>
                                    <input type="file" id="fileUpload" placeholder="File"
                                        (change)="fileChangeEvent($event)" multiple rel="tooltip" title="" /> -->
                                    <!-- accept="image/*"  -->
                                <!-- </span>
                                <a (click)="fileChangeEvent(null)" class="btn btn-danger btn-round fileinput-exists"
                                    data-dismiss="fileinput"><i class="fa fa-times"></i> Remove All Files</a>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="form-check text-left">
                    <label class="form-check-label">
                        <input formControlName="checked" type="checkbox" class="custom-control-input" id="customCheck">
                        <span class="form-check-sign"></span>
                        I agree to the <a (click)="seeTerms()" target="_blank"><b>Terms of Use</b></a> and <a
                            (click)="seePrivacy()" target="_blank"><b>Privacy Policies</b></a> in order to use this
                        application and AMPloyees services. </label>
                </div>

                <div *ngIf="submitted && f.checked.errors" class="alert text-white alert-danger" role="alert">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Agreeing to the Terms of Use and Privacy Policies is required.
                </div> -->

            <!-- </div>

            <div *ngIf="showError" class="alert alert-danger text-white" role="alert">
                <i class="fas fa-exclamation-triangle"></i> &nbsp;
                An error has occurred. Please check your connection and try again.
            </div>

        </div>

        <div *ngIf="!success" class="modal-footer">
            <div class="mr-2">

                <div *ngIf="loading" class="text-center">
                    <div class="spinner-grow text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

                <button [hidden]="loading" type="button" class="btn btn-secondary"
                    (click)="activeModal.close('Close click')" data-dismiss="modal">Cancel</button>
                <button [hidden]="loading" type="submit" class="btn btn-primary">Upload File(s)</button>
            </div>

        </div>
    </form>
</div> -->